// extracted by mini-css-extract-plugin
export default {"root":"profile_root__18cmc"};